<ion-input
	[readonly]="isFormFilledByGps"
	[ngClass]="{
		'error-class':
			form.get(dynamicFormControl.key).invalid &&
			(form.get(dynamicFormControl.key).dirty || form.get(dynamicFormControl.key).touched),
		'disabled-class': isFormFilledByGps
	}"
	appDebounceKeyUpDirective
	[debounce]="isDebounceApplied ? 150 : 0"
	name="dynamicFormControl.key"
	[value]="fieldValue"
	[type]="dynamicFormControl.type"
	inputmode="decimal"
	(ionFocus)="updateFieldHasFocus()"
	(ionChange)="fieldValueChanged($event)"
></ion-input>
<ion-button
	[id]="dynamicFormControl.key"
	fill="clear"
	(click)="getCurrentLocation()"
	[ngClass]="fieldHasFocus ? 'ion-no-margin button-visible' : 'ion-no-margin'"
	size="small">
	<ion-icon name="locate-outline"></ion-icon>
</ion-button>
